__webpack_require__.p = "/newslettery/nowa_scala/";